import React, { useEffect, useState } from "react";
import { Loader2, TrendingUp, Package, CalendarDays, Euro, Users, Star, AlertCircle, ArrowUpRight } from "lucide-react";
import { AdminLayout } from "./AdminLayout";
import { api, euro } from "../../lib/api";

function Kpi({ icon: Icon, label, value, accent, testId }) {
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm" data-testid={testId}>
      <div className="flex items-center justify-between">
        <span className={`inline-flex h-10 w-10 items-center justify-center rounded-lg ${accent}`}><Icon size={18} /></span>
      </div>
      <p className="mt-3 font-heading text-2xl font-extrabold text-slate-900">{value}</p>
      <p className="text-sm text-slate-500">{label}</p>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  return (
    <AdminLayout>
      <h1 className="font-heading text-2xl sm:text-3xl font-extrabold text-slate-900">Dashboard</h1>
      <p className="text-slate-500 mt-1">Overzicht van aanvragen, opdrachten en marges.</p>

      {!stats ? (
        <div className="flex justify-center py-20"><Loader2 className="animate-spin text-slate-400" /></div>
      ) : (
        <>
          <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-4">
            <Kpi icon={AlertCircle} label="Nieuwe aanvragen" value={stats.new_requests} accent="bg-amber-100 text-amber-700" testId="kpi-new-requests" />
            <Kpi icon={Package} label="Open opdrachten" value={stats.open_orders} accent="bg-blue-100 text-blue-700" testId="kpi-open-orders" />
            <Kpi icon={CalendarDays} label="Opdrachten vandaag" value={stats.orders_today} accent="bg-indigo-100 text-indigo-700" testId="kpi-orders-today" />
            <Kpi icon={CalendarDays} label="Deze week" value={stats.orders_week} accent="bg-cyan-100 text-cyan-700" testId="kpi-orders-week" />
          </div>
          <div className="mt-4 grid grid-cols-2 lg:grid-cols-4 gap-4">
            <Kpi icon={Euro} label="Omzet (betaald)" value={euro(stats.revenue)} accent="bg-green-100 text-green-700" testId="kpi-revenue" />
            <Kpi icon={Users} label="Partnerkosten" value={euro(stats.partner_cost)} accent="bg-orange-100 text-orange-700" testId="kpi-partner-cost" />
            <Kpi icon={TrendingUp} label="Brutomarge" value={euro(stats.gross_margin)} accent="bg-emerald-100 text-emerald-700" testId="kpi-margin" />
            <Kpi icon={Star} label="Klantbeoordeling" value={stats.avg_rating ? `${stats.avg_rating}/5` : "—"} accent="bg-yellow-100 text-yellow-700" testId="kpi-rating" />
          </div>

          <div className="mt-6 grid sm:grid-cols-3 gap-4">
            <div className="bg-white border border-slate-200 rounded-xl p-5">
              <p className="text-sm text-slate-500">Openstaande betalingen</p>
              <p className="font-heading text-xl font-bold text-slate-900 mt-1">{stats.open_payments}</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-5">
              <p className="text-sm text-slate-500">Totaal opdrachten</p>
              <p className="font-heading text-xl font-bold text-slate-900 mt-1">{stats.total_bookings}</p>
            </div>
            <div className="bg-white border border-slate-200 rounded-xl p-5">
              <p className="text-sm text-slate-500">Afgerond</p>
              <p className="font-heading text-xl font-bold text-slate-900 mt-1">{stats.completed}</p>
            </div>
          </div>

          <a href="/admin/opdrachten" className="mt-6 inline-flex items-center gap-1 text-brand-orange font-semibold text-sm">Bekijk alle opdrachten <ArrowUpRight size={16} /></a>
        </>
      )}
    </AdminLayout>
  );
}
